<template>
  <div class="day-report-wrap">
    <handleIcon @allScreen="toggleAllScreenFull(!isAllScreen)" :isAllScreen="isAllScreen">
      <template slot="menu">
        <li @click="() => getAllData()">
          <div class="icon">
            <i class="iconfont iconRefresh"></i>
          </div>
          <span>{{ $t('dashboard-bi::default-board::refresh') }}</span>
        </li>
      </template>
    </handleIcon>
    <tooltipLine
      v-if="$store.state.user.sourceType !== 2"
      :visible="!($store.state.user.hasBindData && $store.state.user.hasBindData.isExistShop)"
      :content="'看板没有数据？快来绑定您的店铺，系统就会自动拉取数据啦'"
      :showClose="false"
    ></tooltipLine>
    <el-card>
      <el-row>
        <el-col>
          <label class="label-item">{{ $t('operate-analysis::day-report::shop_name') }}</label>
          <el-select
            :placeholder="$t('system::common::select_placeholder')"
            :popperAppendToBody="false"
            @change="changeShop"
            filterable
            clearable
            class="search-item"
            v-model="params.shopId"
          >
            <el-option
              :key="item.shopId"
              :label="item.shopName"
              :value="item.shopId"
              v-for="item in shopList"
            ></el-option>
          </el-select>
          <label class="label-item">{{ $t('operate-analysis::day-report::time') }}</label>
          <el-date-picker
            :appendToBody="false"
            :clearable="false"
            format="yyyy-MM-dd"
            @change="handlerDateChange"
            class="day-item"
            type="date"
            unlink-panels
            v-model="params.dt"
          ></el-date-picker>
        </el-col>
      </el-row>
    </el-card>

    <el-row :gutter="16">
      <el-col :span="24">
        <dayCardList :cardData="cardOptions" v-loading="cardLoading"></dayCardList>
      </el-col>

      <el-col :lg="24" :md="24" :sm="24" :xl="24">
        <el-row :gutter="16">
          <el-col :span="12">
            <reportCard :config="timeOrderData" v-loading="timeCardLoading"></reportCard>
          </el-col>
          <el-col :span="12">
            <reportCard :config="timePriceData" v-loading="timeCardLoading"></reportCard>
          </el-col>
        </el-row>
      </el-col>

      <el-col :lg="24" :md="24" :sm="24" :xl="24">
        <el-row :gutter="16">
          <el-col :span="8">
            <RangeCard
              :style="`height: ${tableHeight};`"
              :config="salesTopConfig"
              v-loading="salesTopLoading"
            ></RangeCard>
          </el-col>
          <el-col :span="16">
            <reportTable
              @onEnd="onShopTableEnd"
              @btns="onReportBtns"
              :config="shopTableConfig"
              :style="`height: ${tableHeight};`"
              @sort-change="shopSortChange"
              v-loading="tableLoading.shop"
              ref="shopSale"
            >
              <template v-for="(item, index) in shopTableConfig.columns">
                <el-table-column :key="index" :label="item" min-width="150" :prop="item" :sortable="'custom'">
                  <template slot="header">
                    {{ item }}
                    <el-tooltip effect="dark" placement="top-start">
                      <div slot="content">
                        <div>{{ shopTableConfig && shopTableConfig.headerTooltip[item] }}</div>
                      </div>
                      <i
                        class="icon-a-01wenhao iconfont-el table-tooltip"
                        v-show="shopTableConfig && shopTableConfig.headerTooltip[item]"
                      ></i>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <el-popover
                      placement="top-start"
                      trigger="hover"
                      style="margin-right: 24px"
                      v-if="
                        /((\.(png|jpg|gif|svg|jpeg)(\?.*|\/.*)?)|(\?viewid=.*)$)|(\/file\/([^\.]+)\.)/i.test(
                          scope.row[item]
                        )
                      "
                    >
                      <ZImg :src="scope.row[item]" style="width: 250px; height: 250px"></ZImg>
                      <ZImg :src="scope.row[item]" class="goods-image" slot="reference"></ZImg>
                    </el-popover>
                    <span v-else>{{ $dataCheck(scope.row[item]) }}</span>
                  </template>
                </el-table-column>
              </template>
            </reportTable>
          </el-col>
        </el-row>
      </el-col>
      <el-col :lg="24" :md="24" :sm="24" :xl="24">
        <el-row :gutter="16">
          <el-col :span="8">
            <RangeCard
              :style="`height: ${tableHeight};`"
              :config="spuSalesTopConfig"
              v-loading="spuSalesTopLoading"
            ></RangeCard>
          </el-col>
          <el-col :span="16">
            <reportTable
              @onEnd="onSpuTableEnd"
              @btns="onReportBtns"
              :config="spuTableConfig"
              :style="`height: ${tableHeight};`"
              v-loading="tableLoading.spu"
              @sort-change="spuSortChange"
              ref="spuSale"
            >
              <template v-for="(item, index) in spuTableConfig.columns">
                <el-table-column
                  :key="index"
                  :label="item"
                  min-width="160"
                  :prop="item"
                  :sortable="item !== 'SPU图' && 'custom'"
                >
                  <template slot="header">
                    {{ item }}
                    <el-tooltip effect="dark" placement="top-start">
                      <div slot="content">
                        <div>{{ spuTableConfig && spuTableConfig.headerTooltip[item] }}</div>
                      </div>
                      <i
                        class="icon-a-01wenhao iconfont-el table-tooltip"
                        v-show="spuTableConfig && spuTableConfig.headerTooltip[item]"
                      ></i>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <el-popover
                      placement="top-start"
                      trigger="hover"
                      style="margin-right: 24px"
                      v-if="
                        /((\.(png|jpg|gif|svg|jpeg)(\?.*|\/.*)?)|(\?viewid=.*)$)|(\/file\/([^\.]+)\.)/i.test(
                          scope.row[item]
                        )
                      "
                    >
                      <ZImg :src="scope.row[item]" style="width: 250px; height: 250px"></ZImg>
                      <ZImg :src="scope.row[item]" class="goods-image" slot="reference"></ZImg>
                    </el-popover>
                    <span v-else>{{ $dataCheck(scope.row[item]) }}</span>
                  </template>
                </el-table-column>
              </template>
            </reportTable>
          </el-col>
        </el-row>
      </el-col>
      <el-col :lg="24" :md="24" :sm="24" :xl="24">
        <el-row :gutter="16">
          <el-col :span="8">
            <RangeCard
              :style="`height: ${tableHeight};`"
              :config="optimizerTopConfig"
              v-loading="optimizerTopLoading"
            ></RangeCard>
          </el-col>
          <el-col :span="16">
            <reportTable
              @onEnd="onOptimizerTableEnd"
              @btns="onReportBtns"
              :config="optimizerTableConfig"
              @sort-change="optimizerSortChange"
              ref="optimizerSale"
              :style="`height: ${tableHeight};`"
              v-loading="tableLoading.optimizer"
            >
              <template v-for="(item, index) in optimizerTableConfig.columns">
                <el-table-column :key="index" :label="item" min-width="150" :prop="item" :sortable="'custom'">
                  <template slot="header">
                    {{ item }}
                    <el-tooltip effect="dark" placement="top-start">
                      <div slot="content">
                        <div>{{ optimizerTableConfig && optimizerTableConfig.headerTooltip[item] }}</div>
                      </div>
                      <i
                        class="icon-a-01wenhao iconfont-el table-tooltip"
                        v-show="optimizerTableConfig && optimizerTableConfig.headerTooltip[item]"
                      ></i>
                    </el-tooltip>
                  </template>
                  <template slot-scope="scope">
                    <el-popover
                      placement="top-start"
                      trigger="hover"
                      style="margin-right: 24px"
                      v-if="
                        /((\.(png|jpg|gif|svg|jpeg)(\?.*|\/.*)?)|(\?viewid=.*)$)|(\/file\/([^\.]+)\.)/i.test(
                          scope.row[item]
                        )
                      "
                    >
                      <ZImg :src="scope.row[item]" style="width: 250px; height: 250px"></ZImg>
                      <ZImg :src="scope.row[item]" class="goods-image" slot="reference"></ZImg>
                    </el-popover>
                    <span v-else>{{ $dataCheck(scope.row[item]) }}</span>
                  </template>
                </el-table-column>
              </template>
            </reportTable>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <EditHeader v-model="showEditHeader" :list="editColumns" :info="editInfo" @change="changeTableColumns"></EditHeader>
  </div>
</template>

<script>
import moment, { months } from 'moment'
import setConfig from './setConfig'
import { toggleAllScreen } from '@/utils/utils.js'
import dataCard from '@/components/data-analysis/card'
import reportCard from '@/components/data-analysis/report'
import reportTable from '@/components/data-analysis/table'
import { getReports, downloadData, queryData } from '@/server/dashboard'
import { _local } from '@/utils/storage'
import {
  getDailyOverview,
  getDailyOverviewTrend,
  getDailyMonitor,
  getDailySalesTop,
  getDailySpuSalesTop,
  getDailyOptimizerTop,
} from '@/server/etl'
import { pickerOptions } from '@/utils/datepickerConfig'
import { getShopList, getErpShopList } from '@/server/shopList'
import { getMerchantType } from '@/server/user'
// import { getErpMerchant } from '@/server/data'
import handleIcon from '@/components/handle-icon/index.vue'
import dayCardList from './components/dayCardList/index.vue'
import EditHeader from './components/edit-header/index.vue'
import RangeCard from './components/rangeCard/index.vue'
import { getColumnConfig } from '@/server/common'
export default {
  name: 'day-report-wrap',
  components: {
    reportCard,
    dayCardList,
    dataCard,
    handleIcon,
    reportTable,
    EditHeader,
    RangeCard,
  },
  computed: {
    isAllScreen() {
      return this.$store.state.isAllScreen
    },
    merchantId() {
      return this.$store.state.user.merchantId
    },
    sourceType() {
      return this.$store.state.user.sourceType
    },
  },
  mixins: [setConfig],
  data() {
    return {
      showEditHeader: false,
      params: {
        dt: moment().format('YYYY-MM-DD'),
        shopId: undefined,
        orgUnitId: this.$store.state.user.merchantId,
      },
      cardLoading: false,
      timeCardLoading: false,
      salesTopLoading: false,
      spuSalesTopLoading: false,
      optimizerTopLoading: false,
      shopList: [{ shopName: this.$t('system::common::select_all_shop'), shopId: undefined }],
      reportHeight: '400px',
      tableHeight: '448px',
      reports: [13062, 13064, 13063], // 13062店铺 13064spu 13063优化师
      timePriceData: {}, // 分时监控
      timeOrderData: {}, // 分时监控
      cardOptions: {}, //卡片
      boardData: [], // 配置报表列表
      tableLoading: {
        shop: false,
        spu: false,
        optimizer: false,
      },
      pickerOptions,
      editColumns: [],
      editInfo: {
        name: '', // 编辑报表的表头名
        limit: 4, // 最少表头数
      },
      shopTableConfig: {},
      shopColumns: [],
      spuTableConfig: {},
      spuColumns: [],
      optimizerTableConfig: {},
      optimizerColumns: [],
      salesTopConfig: {}, // 店铺排行配置
      spuSalesTopConfig: {}, // spu排行配置
      optimizerTopConfig: {}, // 优化师排行配置
    }
  },
  methods: {
    async init(params) {
      params &&
        Object.keys(params).forEach(item => {
          if (this.params.hasOwnProperty(item)) {
            this.params[item] = params[item]
          }
        })
      this.clearData()
      await this.getShopList()
      this.getCardOptions()
      this.getCardOverviewTrend()
      this.getDailyMonitor()
      this.getDailySalesTop()
      this.getDailySpuSalesTop()
      this.getDailyOptimizerTop()
      await this.getColumnConfig('shop')
      await this.getColumnConfig('spu')
      await this.getColumnConfig('optimizer')
      this.setReportQueryInit(1, () => this.getAllData(true))
    },
    /**
     * @name: 下载报表
     * @param {*} reportId 报表id
     * @param {*} target 目标报表对象 如：
     * @param {*} name 下载报表名称
     * @return {*}
     */
    async downLoadReportData(reportId, target, name) {
      if (this[target].btns) {
        this.$set(
          this[target],
          'btns',
          this.$deepClone(
            this[target].btns.map(item => {
              if (item.call == 'download') {
                item.loading = true
              }
              return item
            })
          )
        )
      }
      const res = await downloadData(
        this.setParamsReport(
          this.boardData.find(item => item.reportID == reportId),
          {
            ...this.params,
            contrastDate: moment(this.params.dt).subtract(1, 'days').format('YYYY-MM-DD'),
            org_unit_id: this.merchantId,
          }
        ),
        name,
        getCookie('saasToken'),
        () => {
          if (this[target].btns) {
            this.$set(
              this[target],
              'btns',
              this.$deepClone(
                this[target].btns.map(item => {
                  if (item.call == 'download') {
                    item.loading = false
                  }
                  return item
                })
              )
            )
          }
        }
      )
    },
    // 报表数据构建Init
    async setReportQueryInit(boardID, callback) {
      if (!(this.boardData && this.boardData.length)) {
        const res = await getReports({
          boardID,
        })
        if (!(res.result && res.result[0])) {
          return false
        }
        this.boardData = res.result
        this.reports = this.reports.filter(item => res.result.map(report => report.reportID).includes(item))
      }

      callback()
    },
    // 报表数据构建
    async setReportQuery(boardID, reportId, callback, offset, sort) {
      if (!(this.boardData && this.boardData.length)) {
        const res = await getReports({
          boardID,
        })
        if (!(res.result && res.result[0])) {
          return false
        }
        this.boardData = res.result
        this.reports = this.reports.filter(item => res.result.map(report => report.reportID).includes(item))
      }
      const data = await queryData(
        this.setParamsReport(
          this.boardData.find(item => item.reportID == reportId),
          {
            ...this.params,
            // 店铺和Spu需要对比日期
            contrastDate: moment(this.params.dt).subtract(1, 'days').format('YYYY-MM-DD'),
            org_unit_id: this.merchantId,
          },
          offset,
          sort
        )
      )
      callback(data)
    },
    // 构建report请求
    setParamsReport(result, params = {}, offset, sort) {
      // 配置params 别名
      const alias = []
      // 是否有时间匹配
      if (params.dt) {
        alias.push('pay_date')
      }
      if (params.shopId) {
        alias.push('brand_id')
      }
      //对比日期
      if (params.contrastDate) {
        alias.push('contrast_date')
      }
      console.log(sort)
      const dimensions = sort
        ? result.requestDimensions.map(el => {
            if (sort && sort.name === el.chinese) {
              return { ...el, sortType: sort.type }
            } else {
              return { ...el, sortType: 'DEFAULT' }
            }
          })
        : result.requestDimensions // 堆积过滤条件concat 条件conditions // 堆积过滤条件concat 条件conditions
      const filters = result.otherParams.filter // 过滤条件，用alias取对应的uuid
      const pageSize = result.otherParams.pageSize
      let conditions = result.requestConditions
      const dirlls = result.drillDimensions
      const measures = sort
        ? result.requestMeasures.map(el => {
            if (sort && sort.name === el.chinese) {
              return { ...el, sortType: sort.type }
            } else {
              return { ...el, sortType: 'DEFAULT' }
            }
          })
        : result.requestMeasures

      // 判断alias 是否匹配到filters值
      alias.forEach(alia => {
        if (filters.some(item => alia == item.alias)) {
          const conditionItem = filters.find(item => alia == item.alias) || {}

          if (conditionItem.columnType == 'DATE') {
            conditions = conditions.filter(item => item.uuid != conditionItem.uuid)
            conditions.push({
              queryType: 'LARGEEQUAL',
              // 店铺和Spu需要对比日期
              requestValue: [
                conditionItem.alias === 'pay_date'
                  ? moment(params.dt).format('YYYY-MM-DD')
                  : moment(params.contrastDate).format('YYYY-MM-DD'),
              ],
              uuid: conditionItem.uuid,
            })
            conditions.push({
              queryType: 'LESSEQUAL',
              requestValue: [
                conditionItem.alias === 'pay_date'
                  ? moment(params.dt).format('YYYY-MM-DD')
                  : moment(params.contrastDate).format('YYYY-MM-DD'),
              ],
              uuid: conditionItem.uuid,
            })
          } else {
            conditions = conditions
              .filter(item => item.requestValue.length)
              .filter(item => item.uuid != conditionItem.uuid)
            const filterItem = filters.find(item => alia == item.alias)
            let queryType = ''
            if (filterItem) {
              queryType = filterItem.filterGroup.filterType.split('-')[1].toUpperCase()
            }
            conditions.push({
              queryType,
              requestValue: [String(params.shopId)],
              uuid: conditionItem.uuid,
            })
          }
        }
      })

      return {
        check: false,
        conditions,
        modelID: result.modelID,
        offSet: offset || 1,
        pageSize,
        reportID: result.reportID,
        dimensions,
        measures,
        dirlls,
      }
    },
    /**
     * @name: 报表操作按钮事件
     * @param {*} emit
     * @return {*}
     */
    onReportBtns(emit) {
      if (emit.call == 'download') {
        this.downLoadReportData(emit.reportId, emit.target, emit.title)
      } else if (emit.call == 'setting') {
        this.showEditHeader = true
        this.editColumns = [...this[`${emit.tableName}Columns`]]
        this.editInfo.name = emit.tableName
      }
    },
    toggleAllScreenFull(bool) {
      this.$store.commit('setScreen', bool)
      toggleAllScreen()
    },
    getAllData(init) {
      if (!init) {
        this.getCardOptions()
        this.getCardOverviewTrend()
        this.getDailyMonitor()
        this.getDailySalesTop()
        this.getDailySpuSalesTop()
        this.getDailyOptimizerTop()
      }
      this.getShopTableConfig()
      this.getSpuTableConfig()
      this.getOptimizerTableConfig()
    },
    changeShop() {
      this.shopTableConfig = {}
      this.spuTableConfig = {}
      this.optimizerTableConfig = {}
      this.getAllData()
    },
    handlerDateChange(date) {
      this.params.dt = moment(date).format('YYYY-MM-DD')
      this.shopTableConfig = {}
      this.spuTableConfig = {}
      this.optimizerTableConfig = {}
      this.getAllData()
    },
    async getShopList() {
      const res = await getMerchantType(this.$store.state.user.merchantId)
      if (res.data.code === this.$code) {
        if (res.data.data === 1) {
          const { data } = await getShopList({ pageSize: 10000, pageNum: 1 })
          if (data.code === this.$code) {
            this.shopList = [...this.shopList, ...((data.data && data.data.items) || [])]
          }
        } else if (res.data.data === 2) {
          const { data } = await getErpShopList(this.merchantId)
          if (data.code === this.$code) {
            this.shopList = [...this.shopList, ...(data.data || [])]
          }
        }
      }
    },
    // 获取日报概览
    async getCardOptions() {
      this.cardLoading = true
      const { data } = await getDailyOverview({
        ...this.params,
        dt:
          moment(this.params.dt).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')
            ? moment().format('YYYY-MM-DD HH:mm:ss')
            : moment(this.params.dt).format('YYYY-MM-DD') + ' 23:59:59',
      })
      this.cardLoading = false
      if (data.code === this.$code) {
        this.$set(
          this.cardOptions,
          'cardItems',
          this.setCardOptions((data.data && data.data.datas && data.data.datas[0]) || {})
        )
      }
    },
    // 获取日报概览趋势
    async getCardOverviewTrend() {
      const { data } = await getDailyOverviewTrend({
        ...this.params,
        dt:
          moment(this.params.dt).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')
            ? moment().format('YYYY-MM-DD HH:mm:ss')
            : moment(this.params.dt).format('YYYY-MM-DD') + ' 23:59:59',
      })
      if (data.code === this.$code) {
        this.cardOptions.trend = (data.data && data.data.datas) || []
      }
    },
    // 获取分时监控
    async getDailyMonitor() {
      this.timeCardLoading = true
      const { data } = await getDailyMonitor({
        ...this.params,
        dt: moment(this.params.dt).format('YYYY-MM-DD') + ' 23:59:59',
      })
      this.timeCardLoading = false
      if (data.code === this.$code) {
        let yAxis = []
        if (data.data && data.data.datas) {
          data.data.datas.forEach(el => {
            if (yAxis.every(item => item !== el.payDate)) {
              yAxis.push(el.payDate)
            }
          })
        }
        this.timePriceData = this.setControlTimePriceData((data.data && data.data.datas) || [], yAxis)
        this.timeOrderData = this.setControlTimeOrderData((data.data && data.data.datas) || [], yAxis)
      }
    },
    // 店铺排行
    async getDailySalesTop() {
      this.salesTopLoading = true
      const { data } = await getDailySalesTop({
        ...this.params,
        dt:
          moment(this.params.dt).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')
            ? moment().format('YYYY-MM-DD HH:mm:ss')
            : moment(this.params.dt).format('YYYY-MM-DD') + ' 23:59:59',
      })
      this.salesTopLoading = false
      if (data.code === this.$code) {
        this.salesTopConfig = this.setSalesTopConfig((data.data && data.data.datas) || [])
      }
    },
    // spu排行
    async getDailySpuSalesTop() {
      this.spuSalesTopLoading = true
      const { data } = await getDailySpuSalesTop({
        ...this.params,
        dt:
          moment(this.params.dt).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')
            ? moment().format('YYYY-MM-DD HH:mm:ss')
            : moment(this.params.dt).format('YYYY-MM-DD') + ' 23:59:59',
      })
      this.spuSalesTopLoading = false
      if (data.code === this.$code) {
        this.spuSalesTopConfig = this.setSpuSalesTopConfig((data.data && data.data.datas) || [])
      }
    },
    // 优化师排行
    async getDailyOptimizerTop() {
      this.optimizerTopLoading = true
      const { data } = await getDailyOptimizerTop({
        ...this.params,
        dt:
          moment(this.params.dt).format('YYYY-MM-DD') == moment().format('YYYY-MM-DD')
            ? moment().format('YYYY-MM-DD HH:mm:ss')
            : moment(this.params.dt).format('YYYY-MM-DD') + ' 23:59:59',
      })
      this.optimizerTopLoading = false
      if (data.code === this.$code) {
        this.optimizerTopConfig = this.setOptimizerTopConfig((data.data && data.data.datas) || [])
      }
    },
    async onShopTableEnd() {
      if (this.shopTableConfig.last) {
        return
      }
      this.getShopTableConfig(1)
    },
    async onSpuTableEnd() {
      if (this.spuTableConfig.last) {
        return
      }
      this.getSpuTableConfig(1)
    },
    async onOptimizerTableEnd() {
      if (this.optimizerTableConfig.last) {
        return
      }
      this.getOptimizerTableConfig(1)
    },
    shopSortChange(data) {
      this.shopTableConfig.offset = 1
      this.shopTableConfig.tableData = []
      this.$refs.shopSale.$refs.shopSale.bodyWrapper.scrollTop = 0
      const type = { descending: 'DESC', ascending: 'ASC' }
      if (data.order) {
        this.shopTableConfig.sort = { name: data.prop, type: type[data.order] }
      } else {
        this.shopTableConfig.sort = null
      }
      this.getShopTableConfig()
    },
    spuSortChange(data) {
      this.spuTableConfig.offset = 1
      this.spuTableConfig.tableData = []
      this.$refs.spuSale.$refs.spuSale.bodyWrapper.scrollTop = 0
      const type = { descending: 'DESC', ascending: 'ASC' }
      if (data.order) {
        this.spuTableConfig.sort = { name: data.prop, type: type[data.order] }
      } else {
        this.spuTableConfig.sort = null
      }
      this.getSpuTableConfig()
    },
    optimizerSortChange(data) {
      this.optimizerTableConfig.offset = 1
      this.optimizerTableConfig.tableData = []
      this.$refs.optimizerSale.$refs.optimizerSale.bodyWrapper.scrollTop = 0
      const type = { descending: 'DESC', ascending: 'ASC' }
      if (data.order) {
        this.optimizerTableConfig.sort = { name: data.prop, type: type[data.order] }
      } else {
        this.optimizerTableConfig.sort = null
      }
      this.getOptimizerTableConfig()
    },
    // 店铺销售明细
    async getShopTableConfig(offset) {
      const reportId = 13062
      if (!this.reports.includes(reportId)) {
        return false
      }
      if (offset && !this.shopTableConfig.last) {
        this.shopTableConfig.offsetLoading = true
        offset = this.shopTableConfig.offset + 1
      } else {
        this.tableLoading.shop = true
      }
      this.setReportQuery(
        1,
        reportId,
        data => {
          if (data.status === 200) {
            this.shopTableConfig = this.setShopTableConfig(
              data.columnMetas,
              data.result.table,
              reportId,
              offset,
              this.shopTableConfig,
              data.last
            )
            if (offset) {
              this.shopTableConfig.offsetLoading = false
            }
          }
          this.tableLoading.shop = false
        },
        offset,
        this.shopTableConfig.sort || null
      )
    },
    // spu销售明细
    async getSpuTableConfig(offset) {
      const reportId = 13064
      if (!this.reports.includes(reportId)) {
        return false
      }
      if (offset && !this.spuTableConfig.last) {
        this.spuTableConfig.offsetLoading = true
        offset = this.spuTableConfig.offset + 1
      } else {
        this.tableLoading.spu = true
      }
      this.setReportQuery(
        1,
        reportId,
        data => {
          if (data.status === 200) {
            this.spuTableConfig = this.setSpuTableConfig(
              data.columnMetas,
              data.result.table,
              reportId,
              offset,
              this.spuTableConfig,
              data.last
            )
            if (offset) {
              this.spuTableConfig.offsetLoading = false
            }
          }
          this.tableLoading.spu = false
        },
        offset,
        this.spuTableConfig.sort || null
      )
    },
    // 优化师
    async getOptimizerTableConfig(offset) {
      const reportId = 13063
      if (!this.reports.includes(reportId)) {
        return false
      }
      if (offset && !this.optimizerTableConfig.last) {
        this.optimizerTableConfig.offsetLoading = true
        offset = this.optimizerTableConfig.offset + 1
      } else {
        this.tableLoading.optimizer = true
      }
      this.setReportQuery(
        1,
        reportId,
        data => {
          if (data.status === 200) {
            this.optimizerTableConfig = this.setOptimizerTableConfig(
              data.columnMetas,
              data.result.table,
              reportId,
              offset,
              this.optimizerTableConfig,
              data.last
            )
            console.log(this.optimizerTableConfig, 'sdfsdfs')
            if (offset) {
              this.optimizerTableConfig.offsetLoading = false
            }
          }
          this.tableLoading.optimizer = false
        },
        offset,
        this.optimizerTableConfig.sort || null
      )
    },
    // 获取表头配置
    async getColumnConfig(colunmsName) {
      let list = []
      const { data } = await getColumnConfig({ tableName: colunmsName })
      if (data.code === this.$code) {
        const obj = data.data || {}
        if (obj.columns) {
          list = JSON.parse(obj.columns)
        }
      }
      this[`${colunmsName}Columns`] = list
    },
    changeTableColumns(info) {
      this[`${info.name}Columns`] = info.list
      switch (info.name) {
        case 'shop':
          this.shopTableConfig = {}
          this.getShopTableConfig()
          break
        case 'spu':
          this.spuTableConfig = {}
          this.getSpuTableConfig()
          break
        case 'optimizer':
          this.optimizerTableConfig = {}
          this.getOptimizerTableConfig()
          break
      }
    },
    clearData() {
      this.timePriceData = this.setControlTimePriceData([], []) // 分时监控
      this.timeOrderData = this.setControlTimeOrderData([], [])
      this.$set(this.cardOptions, 'cardItems', this.setCardOptions({}))
      this.salesTopConfig = this.setSalesTopConfig([])
      this.spuSalesTopConfig = this.setSpuSalesTopConfig([])
      this.optimizerTopConfig = this.setOptimizerTopConfig([])
    },
  },
  activated() {
    this.$store.dispatch('updateRouter', [this.$route, this.init])
  },
  async mounted() {
    this.init()
  },
}
</script>

<style lang="scss" scoped>
.day-report-wrap {
  position: relative;
  z-index: 8;
}
.control-btn-wrap {
  text-align: right;
  margin-bottom: 8px;
  .item-btn {
    margin-left: 16px;
  }
}
.label-item {
  margin-right: 8px;
}
.search-item {
  margin-right: 16px;
  width: 180px;
}
.day-item {
  width: 204px;
}
.icon {
  color: #999;
}
.goods-image {
  width: 64px;
  height: 64px;
  border-radius: 5px;
  border: 1px solid #d9d9d9;
}
.table-tooltip {
  color: #999;
  font-size: 14px;
}
</style>
